<template>
  <div class="vx-col w-full">
    <vx-card class="digitelex-popup-content">
      <form>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'required|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Client Name"
              label-placeholder="Client Name"
              name="clientName"
              v-model="frm.clientName"
              v-on:keyup="updateBillingName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('clientName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("clientName") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('clientName')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'required|decimal:10'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Mobile No "
              label-placeholder="Mobile No "
              name="mobileNo"
              v-model="frm.mobileNo"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('mobileNo')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("mobileNo") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('mobileNo')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              v-validate="'email'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Email"
              label-placeholder="Email"
              name="email"
              v-model="frm.email"
              type="text"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('email')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("email") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('email')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              placeholder="GST No "
              label-placeholder="GST No "
              name="gstNo"
              v-model="frm.gstNo"
              type="text"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('gstNo')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("gstNo") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('gstNo')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-select
              autocomplete
              class="Locations"
              label="Locations"
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur|click"
              placeholder="Locations"
              label-placeholder="vs-Multiple"
              v-model="frm.locationId"
              icon="arrow_downward"
              width="100%"
            >
              <vs-select-item
                :key="index"
                :value="item.locationId"
                :text="item.locationName"
                v-for="(item, index) in locations"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              v-validate="'required|numeric|min:6|max:7'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Zip Code"
              label-placeholder="Zip Code"
              name="zipCode"
              v-model="frm.zipCode"
              type="text"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('zipCode')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("zipCode") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('zipCode')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-textarea
              counter="200"
              height="40"
              label="Address: max(200)"
              :counter-danger.sync="addressDanger"
              name="address"
              v-model="frm.address"
              v-on:keyup="updateBillingAddress"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <span class="digitelex-overflow-label-container">
              <label class="digitelex-overflow-label">Send Text Message</label>
              <vx-tooltip
                position="bottom"
                text="By enabling it user will get the text messages"
              >
                <vs-button
                  size="small"
                  radius
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
            <vs-switch
              class="digitelex-switch-amargin"
              v-model="frm.needMessage"
            />
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <span class="digitelex-overflow-label-container">
              <label class="digitelex-overflow-label"
                >Send Whatsapp Message</label
              >
              <vx-tooltip
                position="bottom"
                text="By enabling it user will get the whatsapp messages"
              >
                <vs-button
                  size="small"
                  radius
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
            <vs-switch
              class="digitelex-switch-amargin"
              v-model="frm.needWhatsapp"
            />
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <span class="digitelex-overflow-label-container">
              <label class="digitelex-overflow-label">Send Email</label>
              <vx-tooltip
                position="bottom"
                text="By enabling it user will get the email"
              >
                <vs-button
                  size="small"
                  radius
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
            <vs-switch
              class="digitelex-switch-amargin"
              v-model="frm.needEmail"
            />
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <span class="digitelex-overflow-label-container">
              <label class="digitelex-overflow-label">Send Wishes</label>
              <vx-tooltip
                position="bottom"
                text="By enabling it user will get the special days wishes"
              >
                <vs-button
                  size="small"
                  radius
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
            <vs-switch
              class="digitelex-switch-amargin"
              v-model="frm.sendGreetings"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              placeholder="Contact Person Mobile No"
              label-placeholder="Contact Person Mobile No "
              name="clientContactPersonName"
              v-model="frm.clientContactPersonName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('clientContactPersonName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("clientContactPersonName") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('clientContactPersonName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              placeholder="Mobile No "
              label-placeholder="Mobile No "
              name="clientContactPersonMobileNo"
              v-model="frm.clientContactPersonMobileNo"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('clientContactPersonMobileNo')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("clientContactPersonMobileNo") }}
              </span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('clientContactPersonMobileNo')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              placeholder="Billing Name"
              label-placeholder="Billing Name"
              name="billingName"
              v-model="frm.billingName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('billingName')"
            >
              <span class="digitelex-form-error-message">
                {{ errors.first("billingName") }}
              </span>
              <vx-tooltip position="bottom" :text="errors.first('billingName')">
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-textarea
              counter="200"
              height="40"
              label="Billing Address: max(200)"
              :counter-danger.sync="billingAddressDanger"
              name="billingAddress"
              v-model="frm.billingAddress"
            />
          </div>
        </div>
        <div class="flex flex-wrap justify-end">
          <vs-button
            :disabled="!validateForm"
            @click="saveClient"
            class="ml-auto"
            >Save Changes</vs-button
          >
          <vs-button class="ml-4" type="border" color="warning"
            >Cancel</vs-button
          >
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);

export default {
  props: {
    frmData: {},
  },
  methods: {
    getLocations() {
      this.$http.get("common/locations").then((response) => {
        this.locations = response.data.data;
      });
    },
    saveClient() {
      if (this.frm.clientId) {
        //Update
        // alert("Updated");
        this.$http
          .put("portage/client", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.frm.isActive = true;
        this.frm.clientId = 0;
        this.$http
          .post("portage/client", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    updateBillingName() {
      if (!this.fields.billingName.touched) {
        this.frm.billingName = this.frm.clientName;
      }
    },
    updateBillingAddress() {
      this.frm.billingAddress = this.frm.address;
      // return true;
    },
  },
  data() {
    return {
      locations: [],
      addressDanger: false,
      billingAddressDanger: false,
      frm: {
        address: null,
        billingAddress: null,
        billingName: null,
        clientContactPersonMobileNo: null,
        clientContactPersonName: null,
        clientId: null,
        clientName: null,
        clientUniq: null,
        email: null,
        gstNo: null,
        isActive: null,
        locationId: -1,
        locationName: null,
        mobileNo: null,
        needEmail: null,
        needMessage: null,
        needWhatsapp: null,
        sendGreetings: null,
        zipCode: null,
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        this.frm = after;
      },
      immediate: true,
    },
  },

  computed: {
    validateForm() {
      // console.log(this.fields.billingName, this.fields.billingName);
      return (
        !this.errors.any() &&
        this.frm.clientName != "" &&
        this.frm.clientName != null
      );
    },
  },
  beforeMount() {
    if (!this.frm.clientId) {
      this.frm.needEmail = false;
      this.frm.needMessage = false;
      this.frm.needWhatsapp = false;
      this.frm.sendGreetings = false;
    }
    // console.log(this.frmData);
    this.getLocations();
  },
};
</script>
